document.addEventListener('DOMContentLoaded', () => {
    const getSection = document.querySelector('.content-with-image.interactive-tabs');
    if (getSection) {
        const tabs = getSection.querySelectorAll('li');
        const dropDown = getSection.querySelector('.content-right ul');
        const animationDuration = 500;

        function setDropDownHeight() {
            if (window.innerWidth > 767) {
                const dropDownHeight = dropDown.scrollHeight;
                const parent = dropDown.parentElement;
                parent.style.height = dropDownHeight + 'px';
            } else {
                // Reset height to auto when below 767px
                const parent = dropDown.parentElement;
                parent.style.height = 'auto';
            }
        }

        // Update height on window resize if above 767px
        function onResizeOrLoad() {
            if (window.innerWidth > 767) {
                setTimeout(function () {
                    setDropDownHeight();
                }, 200);
            }
        }

        // Initial height update on page load if above 767px
        // onResizeOrLoad();

        // Add resize and load event listeners
        window.addEventListener('resize', onResizeOrLoad);
        window.addEventListener('load', onResizeOrLoad);

        if (tabs.length > 0) {
            const contents = tabs[0].querySelector('.hidden-content');
            tabs[0].classList.add('active');
            contents.style.height = 'auto';
            contents.style.display = 'block';
        }

        function slideUp(element) {
            element.animate([
                { height: element.scrollHeight + 'px' },
                { height: '0' }
            ], {
                duration: animationDuration,
                easing: 'ease'
            }).onfinish = function () {
                element.style.height = '0';
                element.style.display = 'none'; // Hide after animation
            };
        }

        function slideDown(element) {
            element.style.display = 'block'; // Show before animation
            element.animate([
                { height: '0' },
                { height: element.scrollHeight + 'px' }
            ], {
                duration: animationDuration,
                easing: 'ease'
            }).onfinish = function () {
                element.style.height = element.scrollHeight + 'px';
            };
        }

        tabs.forEach(tab => {
            tab.addEventListener('click', function () {
                const target = this.querySelector('.interactive-tabs li .hidden-content');

                // Slide up all other hidden contents except the current target
                getSection.querySelectorAll('li .hidden-content').forEach(child => {
                    if (child !== target) {
                        slideUp(child);
                    }
                });

                // Slide down the current target
                slideDown(target);

                // Remove active and prev-elm class from all tabs
                tabs.forEach(tab => {
                    tab.classList.remove('active');
                    tab.classList.remove('prev-elm');
                });

                // Add active class to the clicked tab
                tab.classList.add('active');

                // Add prev-elm class to the previous sibling, if it exists
                const prevTab = tab.previousElementSibling;
                if (prevTab) {
                    prevTab.classList.add('prev-elm');
                }
            });
        });
    }
});
